export function BrandMark({ tagline = true, collapsed = false, light = false }) {
  const textColor = light ? "text-white" : "text-foreground";
  const taglineColor = light ? "text-brandgreen-300" : "text-muted-foreground";
  return (
    <div className="inline-flex items-center gap-2.5" data-testid="brand-mark">
      <img src="/brand/sarenew-logo.png" alt="SA Renew" className="h-9 w-9 shrink-0 object-contain" />
      {!collapsed && (
        <div>
          <div className={`font-logo text-lg font-bold leading-none tracking-tight ${textColor}`}>
            SA <span className="text-gold-500">Renew</span>
          </div>
          {tagline && (
            <div className={`mt-1 text-[9px] font-semibold uppercase tracking-[0.22em] ${taglineColor}`}>
              Ground to Grid
            </div>
          )}
        </div>
      )}
    </div>
  );
}
